import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;
